import { Injectable } from '@angular/core';
import { PBBEvents } from '@core/constants/events';
import { WindowService } from '@core/services/window.service';
import { SNAME } from '@core/constants/storage';
import { v4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class CheckoutSdkEventsService {
  constructor(private readonly windowService: WindowService) {}

  /**
   * Fire shipping options request event to merchant SDK
   * Called when user selects an address and clicks continue
   */
  requestShippingOptions(postalCode: string): void {
    this.windowService.sendToMerchant(PBBEvents.konekShippingOptions, false, {
      type: 'requestOptions',
      postal_code: postalCode,
      is_rural_postal_code: 'false',
      request_id: v4(),
      correlation_id: sessionStorage.getItem(SNAME.CORRELATIONID),
      locales: 'en-CA',
    });
  }

  /**
   * Fire consent update event to merchant SDK
   * Called when user selects a shipping option and clicks continue
   */
  requestConsentUpdate(shippingOptionId: string): void {
    this.windowService.sendToMerchant(PBBEvents.konekShippingOptions, false, {
      type: 'selectedOption',
      request_id: v4(),
      shipping_option_id: shippingOptionId,
    });
  }
}
